<template>
  <div class="home-page cg-page" style="padding-top: 0;">
    <div class="login-content">
      <div class="" style="text-align: center">
        <img style="width: 35%" src="../../static/images/logo.png">
      </div>
      <div >
        <div class="">
          <div class="home-prize" style="padding-top:30px;">

          </div>

          <div class="span fs33 ac mt30 app-en" style="width:50%;margin: 0 auto;color: white">
            {{ msg }}
          </div>

          <div class="ac mt50">
            <button class="btn error-login-button">
              <span @click="goLogin">ចូល</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  components:{

  },
  data() {
    return {
      msg:'',
    }
  },
  created(){
    let msg = this.$route.query.msg
    if(msg){
      this.msg = msg
    }
    if(localStorage.getItem('lang')) this.isEN = localStorage.getItem('lang')
  },
  methods: {
    goLogin(){
      this.$router.push({path:'/'});
    },
  }
}
</script>

<style scoped>
.error-login-button {
  font-size: clamp(22px, 5vw, 32px) !important;
  height: clamp(64px, 14vw, 84px) !important;
  line-height: 1.2 !important;
  min-width: 0 !important;
  padding: 0 20px !important;
  width: min(260px, 58vw);
}
</style>



// WEBPACK FOOTER //
// src/page/errors.vue